export default __webpack_public_path__ + "static/media/keto_box@3x.8decee01.jpg";